import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import $ from 'jquery';
import 'datatables.net-bs5';
import { API_URL, BASE_URL } from './Config';
import config from "./common/Config";
import 'jquery-ui/ui/widgets/resizable';
import 'jquery-ui/themes/base/all.css'; // Optional: for default styles
import { setTableWidths, getTableWidths } from "../data/postAPi";

const CompleteTrips = () => {
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [completeTrips, setCompleteTrips] = useState([]); // State to store statistics data
  const [draw, setDraw] = useState(1);
  const [start, setStart] = useState(0);
  const [length, setLength] = useState(50);
  const accessToken = localStorage.getItem('accessToken');
  const salesOrderRef = useRef(null);
  const [colWidths, setColWidths] = useState([60, 120, 120, 150, 150, 150, 120]);
  const userId = localStorage.getItem("userId");
  const tableName = "completeTripsTable";
  function debounce(func, wait) {
    let timeout;
    return function (...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  }
  const debouncedSetTableWidths = useRef(
    debounce((userId, tableName, widths) => {
      setTableWidths(userId, tableName, widths);
    }, 500)
  ).current;
  function startResizing(index, e) {
    e.preventDefault();
    const startX = e.clientX;
    const startWidth = colWidths[index];
    const onMouseMove = (moveEvent) => {
      const newWidth = Math.max(50, startWidth + moveEvent.clientX - startX);
      setColWidths((widths) => {
        const updated = [...widths];
        updated[index] = newWidth;
        debouncedSetTableWidths(userId, tableName, updated);
        return updated;
      });
    };
    const onMouseUp = () => {
      document.removeEventListener("mousemove", onMouseMove);
      document.removeEventListener("mouseup", onMouseUp);
    };
    document.addEventListener("mousemove", onMouseMove);
    document.addEventListener("mouseup", onMouseUp);
  }
  const fetchWidths = async () => {
    try {
      const res = await getTableWidths(userId, tableName);
      if (res?.data?.widths && Array.isArray(res.data.widths) && res.data.widths.length > 0) {
        setColWidths(res.data.widths);
      } else {
        setColWidths([60, 120, 120, 150, 150, 150, 120]);
      }
    } catch (e) {
      setColWidths([60, 120, 120, 150, 150, 150, 120]);
    }
  };


  const handleSubmit = (e) => {
    e.preventDefault();
    fetchData();
  };

  useEffect(() => {
    if (accessToken === null) {
      window.location.href = `${config.BASE_URL}/login`;
      return;
    }
    fetchData();
  }, [fromDate, toDate]);




  const fetchData = (startDate, endDate) => {
    const $table = $(salesOrderRef.current);
    if (!$table.length) return;

    // Destroy existing DataTable instance to prevent reinitialization issues
    if ($.fn.DataTable.isDataTable($table)) {
      $table.DataTable().destroy();
    }

    // Initialize DataTable
    $table.DataTable({
      processing: true,
      serverSide: true,
      autoWidth:false,
      pageLength: 50,
      ajax: {
        url: `${config.API_URL}/get_complete_trip_list`,
        type: "POST",
        headers: {
          authorization: `Bearer ${accessToken}`,
        },
        data: function (d) {
          return {
            ...d,
            draw: d.draw,
            start: d.start,
            length: d.length,
            searchByFromdate: startDate,
            searchByTodate: endDate,
          };
        },
        dataSrc: function (json) {
          if (json?.data && Array.isArray(json.data)) {
            setCompleteTrips(json.data);
            setTimeout(fetchWidths, 0);
            return json.data;
          }
          setTimeout(fetchWidths, 0);
          return [];
        },
        error: function (xhr) {
          console.error("DataTable AJAX error:", xhr.responseText);
        },
      },
      language: {
        paginate: {
          first: "First",
          last: "Last",
          next: "Next",
          previous: "Previous",
        },
        search: "Search:",
      },
      columns: [
        { data: null, width: colWidths[0] + 'px' },
        { data: 'date', width: colWidths[1] + 'px' },
        {
          data: 'trip_number',
          width: colWidths[2] + 'px',
          render: function (data, type, row) {
            return '<a href="' + BASE_URL + '/complete_trips/closed_trip_summary/' + row.id + '">' + row.trip_number + '</a>';
          }
        },
        { data: 'driver', width: colWidths[3] + 'px' },
        { data: 'vehicle', className: "text-center", width: colWidths[4] + 'px' },
        { data: 'route_number', width: colWidths[5] + 'px' },
        {
          data: null,
          width: colWidths[6] + 'px',
          render: function (data, type, row) {
            return '<span class="btn btn-primary badge " >' + row.status + '</span>';
          }
        },
      ],
      columnDefs: [
        {
          targets: [0, 1, 2, 3, 4, 5],
          sortable: false
        }],
      drawCallback: function (settings) {
        var api = this.api();
        var startIndex = api.page.info().start;
        api.column(0, { page: 'current' }).nodes().each(function (cell, i) {
          cell.innerHTML = startIndex + i + 1;
        });
        const resizers = document.querySelectorAll('.complete-trips-area .th-resizer');
        resizers.forEach((resizer, index) => {
          const handleMouseDown = (e) => {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            startResizing(index, e);
          };
          resizer.addEventListener('mousedown', handleMouseDown);
          resizer._resizerHandler = handleMouseDown;
        });
        $('.complete-trips-area thead th').each(function(idx) {
          $(this).css('width', colWidths[idx] + 'px');
        });
      }
    });



    // Cleanup on unmount
    return () => {
      if ($.fn.DataTable.isDataTable($table)) {
        $table.DataTable().destroy();
      }
    };
  };

  const resizerStyles = `
    .th-resizer:hover {
      background-color: rgba(0, 0, 0, 0.3) !important;
    }
    .resizable-header {
      position: relative;
      user-select: none;
    }
  `;
  useEffect(() => {
    const styleSheet = document.createElement('style');
    styleSheet.textContent = resizerStyles;
    document.head.appendChild(styleSheet);
    return () => {
      if (document.head.contains(styleSheet)) {
        document.head.removeChild(styleSheet);
      }
    };
  }, []);


  return (
    <div>
      <Header />
      <div className="breadcrumbs">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 col-lg-12 col-sm-12">
              <Link to="/Dashboard"><i className="fa fa-home"></i></Link>
              <Link to="/CompleteTrips">Closed Trips</Link>
            </div>
          </div>
        </div>
      </div>
      <div className="main-container">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 col-lg-12 col-sm-12">
              <div className="dashboard">

                <div className="verical-scrl-wrapper complete-trips-area" id="style-3" style={{ marginTop: '0px', width: '100%' }} >
                  <table className="table table-bordered dataTable resizable" ref={salesOrderRef}>
                    <thead>
                      <tr>
                        {["Sr.No.", "Date", "Trip ID", "Driver", "Vehicle", "Route", "Status"].map((header, idx) => (
                          <th
                            key={header}
                            className="resizable-header"
                            style={{
                              width: colWidths[idx],
                              minWidth: 50,
                              position: "relative",
                              padding: "8px"
                            }}
                          >
                            {header}
                            {idx < colWidths.length - 1 && (
                              <div
                                className="th-resizer"
                                data-column-index={idx}
                                title="Drag to resize column"
                                style={{
                                  position: 'absolute',
                                  right: '-2px',
                                  top: 0,
                                  width: '5px',
                                  height: '100%',
                                  cursor: 'col-resize',
                                  zIndex: 999,
                                  userSelect: 'none'
                                }}
                              />
                            )}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>

                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default CompleteTrips;
